import React, { Fragment } from 'react';
import styled from 'styled-components';
import { CurrencyText } from '@components/currency';
import { useMembers } from '../../../hooks';
import { SectorColors } from '../../../utils';
import { MembersGridItem } from './members-grid-item';

export const MembersGrid = () => {
  const { totalSum, members } = useMembers();
  return (
    <Container>
      <div className="grid-header blue">
        <span>
          <i className="icon-users" />
        </span>
        <span>
          <CurrencyText value={totalSum[SectorColors.BLUE]} />
        </span>
      </div>
      <div className="grid-header red">
        <span>
          <i className="icon-users" />
        </span>
        <span>
          <CurrencyText value={totalSum[SectorColors.RED]} />
        </span>
      </div>
      <div className="grid-header green">
        <span>
          <i className="icon-users" />
        </span>
        <span>
          <CurrencyText value={totalSum[SectorColors.GREEN]} />
        </span>
      </div>
      <div className="grid-header gold">
        <span>
          <i className="icon-users" />
        </span>
        <span>
          <CurrencyText value={totalSum[SectorColors.GOLD]} />
        </span>
      </div>
      {(Object.keys(members) as SectorColors[]).map(key => (
        <Fragment key={key}>
          {Object.keys(members[key]).map((playerId: any) => (
            <MembersGridItem key={members[key][playerId].id} {...members[key][playerId]} />
          ))}
        </Fragment>
      ))}
    </Container>
  );
};

const Container = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 0.125rem 0.25rem;
  padding: 1.75rem 1rem;

  & .grid-header {
    display: grid;
    grid-auto-flow: row;
    grid-auto-rows: min-content;
    grid-gap: 0.25rem;
    align-content: center;
    height: 2.75rem;
    background: var(--color-dark-200);
    order: -10000;

    &.blue {
      border-top: 0.25rem solid var(--x50-blue-stroke);
    }
    &.red {
      border-top: 0.25rem solid var(--x50-red-stroke);
    }
    &.green {
      border-top: 0.25rem solid var(--x50-green-stroke);
    }

    &.gold {
      border-top: 0.25rem solid var(--x50-gold-stroke);
    }

    & span {
      font-size: 0.8125rem;
      line-height: 1rem;
      letter-spacing: 2px;
      color: var(--color-white);
      text-align: center;
      height: 0.875rem;

      &:last-of-type {
        font-weight: bold;
      }

      & i {
        font-size: 0.875rem;
        margin-right: 0.25rem;
      }
    }
  }

  & .blue {
    grid-column: 1;
  }

  & .red {
    grid-column: 2;
  }

  & .green {
    grid-column: 3;
  }

  & .gold {
    grid-column: 4;
  }
`;
